import React from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  GlobalOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  SafetyOutlined,
  LinkOutlined,
  ApiOutlined,
  CloudServerOutlined,
  BarChartOutlined,
  LineChartOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/websites',
      icon: <GlobalOutlined />,
      label: 'Websites',
    },
    {
      key: '/videos',
      icon: <PlayCircleOutlined />,
      label: 'Videos',
    },
    {
      key: '/whitelist',
      icon: <SafetyOutlined />,
      label: 'WhiteList IPs',
    },
    {
      key: '/spam-links',
      icon: <LinkOutlined />,
      label: 'Spam Link',
    },
    {
      key: '/webhook-status',
      icon: <ApiOutlined />,
      label: 'Webhook Status',
    },
    {
      key: '/server-management',
      icon: <CloudServerOutlined />,
      label: 'Server Management',
    },
    {
      key: '/multi-server-statistics',
      icon: <BarChartOutlined />,
      label: 'Global Statistics DirWeb',
    },
    {
      key: '/ga-traffic',
      icon: <LineChartOutlined />,
      label: 'GA Traffic',
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  return (
    <Sider
      width={250}
      style={{
        background: 'var(--sidebar-bg)',
        boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        borderBottom: '1px solid var(--sidebar-border)' 
      }}>
        <h2 style={{ margin: 0, color: 'var(--text-primary)' }}>Admin Panel</h2>
        <p style={{ 
          margin: '5px 0 0 0', 
          color: 'var(--text-secondary)', 
          fontSize: '12px' 
        }}>
          Website Management System
        </p>
      </div>
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
        style={{ 
          border: 'none', 
          marginTop: '20px',
          background: 'var(--sidebar-bg)'
        }}
      />
    </Sider>
  );
};

export default Sidebar;
